import React from 'react'
import '../css/Navbar.css';
const Marquee = () => {
  return (
    <div className="alert-text marquee-container">
      
        <marquee style={{ color: "white" }} scrollamount="7">
India’s hospital industry is witnessing strong growth and investor confidence.;  Private equity firms are actively investing, and several hospital chains are planning IPOs. AI in Cancer Care: India achieved a breakthrough with a mask-free, simulation less radiotherapy technique for cancer care; AI & RNA Megadeals: Artificial intelligence continues to transform drug discovery, highlighted by Alnylam Pharmaceuticals ; FDA proposes ban on bulk compounding of semaglutide and tirzepatide.
        </marquee>
    
    </div>
  )
}

export default Marquee
